<template>
  <div
    tabindex="-1"
    :class="[
      `fixed rounded top-2 right-2 z-100 py-2 px-5 z-[500] ${errorObject ? 'bg-red-500' : 'bg-green-500'} text-white transition-all ease-in-out duration-300`,
      dialog ? 'visible' : 'hidden-right',
    ]"
    @transitionend="onTransitionEnd"
    @mouseenter="pauseTimer"
    @mouseleave="resumeTimer">
    <div class="flex items-center gap-2">
      <i :class="`${errorObject ? 'fas fa-exclamation-triangle' : 'fas fa-check-circle text-xl'}`"></i>

      <div>
        <div class="flex items-center">
          <span>{{ message ?? 'Sucesso' }}</span>
          <i class="fas fa-times pl-5 text-sm cursor-pointer" @click="close"></i>
        </div>
        <div class="h-1 bg-white mt-2 transition-all duration-200" :style="{ width: progressBarWidth + '%' }"></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch, onUnmounted } from 'vue'
import { useStore } from 'vuex'

const emit = defineEmits(['transitioned'])
const store = useStore()

// State do Vuex
const successObject = computed(() => store.state.successObject)
const errorObject = computed(() => store.state.errorObject)

// State local
const dialog = ref(false)
const message = ref(null)
const progressBarWidth = ref(100)
const timer = ref(null)
const startTime = ref(null)
const remainingTime = ref(4000)
const intervalDuration = 100

// Métodos
function close() {
  dialog.value = false
  store.dispatch('setSuccess', null)
  store.dispatch('setError', null)
}

function onTransitionEnd() {
  if (!dialog.value) {
    emit('transitioned')
    resetTimer()
  }
}

function startTimer() {
  startTime.value = Date.now()
  clearInterval(timer.value)
  timer.value = setInterval(() => {
    const elapsedTime = Date.now() - startTime.value
    remainingTime.value -= elapsedTime
    startTime.value = Date.now()

    if (remainingTime.value > 0) {
      progressBarWidth.value = (remainingTime.value / 4000) * 100
    } else {
      close()
      resetTimer()
    }
  }, intervalDuration)
}

function resetTimer() {
  clearInterval(timer.value)
  progressBarWidth.value = 100
  remainingTime.value = 4000
}

function pauseTimer() {
  clearInterval(timer.value)
}

function resumeTimer() {
  startTime.value = Date.now()
  clearInterval(timer.value)
  timer.value = setInterval(() => {
    const elapsedTime = Date.now() - startTime.value
    remainingTime.value -= elapsedTime
    startTime.value = Date.now()

    if (remainingTime.value > 0) {
      progressBarWidth.value = (remainingTime.value / 4000) * 100
    } else {
      close()
      resetTimer()
    }
  }, intervalDuration)
}

// Watchers
watch(successObject, (val) => {
  if (val) {
    message.value = val?.message || 'Sucesso'
    dialog.value = true
    resetTimer()
    startTimer()
  }
})

watch(errorObject, (val) => {
  if (val) {
    message.value = val?.message || 'Erro'
    dialog.value = true
    resetTimer()
    startTimer()
  }
})

// Cleanup
onUnmounted(() => {
  clearInterval(timer.value)
})
</script>

<style>
.hidden-right {
  transform: translateX(100%);
  opacity: 0;
}

.visible {
  transform: translateX(0);
  opacity: 1;
}
.transition-width {
  transition: width 0.2s ease-in-out;
}
</style>
